import React, { useState, useEffect, Fragment, useContext } from 'react'
import { Row, Col } from 'reactstrap'
import { useForm, Controller, useWatch } from 'react-hook-form'
import { TextFieldHookForm, SearchableSelectHookForm } from '../../../../layout/HookFormInputs'
import { checkForDecimalAndNull, checkForNull, getConfigurationKey, number, decimalAndNumberValidation } from '../../../../../helper'
import Toaster from '../../../../common/Toaster'
import { costingInfoContext } from '../../CostingDetailStepTwo'
import { KG, EMPTY_DATA } from '../../../../../config/constants'
import { AgGridColumn, AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-material.css';
import { debounce } from 'lodash'
import LoaderCustom from '../../../../common/LoaderCustom';
import TooltipCustom from '../../../../common/Tooltip'
import { reactLocalStorage } from 'reactjs-localstorage'



const gridOptions = {};
function StandardRub(props) {

    const { rmRowData, rmData } = props
    const WeightCalculatorRequest = props.rmRowData.WeightCalculatorRequest;

    const costData = useContext(costingInfoContext)
    const [tableData, setTableData] = useState([])
    const [disableCondition, setDisableCondition] = useState(true)
    const [agGridTable, setAgGridTable] = useState(true)
    const [totalRMCost, setTotalRMCost] = useState("")
    const [rmDropDownData, setRmDropDownData] = useState([])
    const [rmRowDataState, setRmRowDataState] = useState({})
    const [gridApi, setGridApi] = useState(null);
    const [gridColumnApi, setGridColumnApi] = useState(null);
    const [dataToSend, setDataToSend] = useState({ ...WeightCalculatorRequest })
    const [isDisable, setIsDisable] = useState(false)
    const [reRender, setRerender] = useState(false)

    const defaultValues = {
        shotWeight: WeightCalculatorRequest && WeightCalculatorRequest.ShotWeight !== null ? checkForDecimalAndNull(WeightCalculatorRequest.ShotWeight, getConfigurationKey().NoOfDecimalForInputOutput) : '',
        noOfCavity: WeightCalculatorRequest && WeightCalculatorRequest.Cavity !== undefined ? checkForDecimalAndNull(WeightCalculatorRequest.Cavity, getConfigurationKey().NoOfDecimalForInputOutput) : 1,
        grossWeight: WeightCalculatorRequest && WeightCalculatorRequest.GrossWeight !== null ? checkForDecimalAndNull(WeightCalculatorRequest.GrossWeight, getConfigurationKey().NoOfDecimalForInputOutput) : '',
        finishWeight: WeightCalculatorRequest && WeightCalculatorRequest.FinishWeight !== null ? checkForDecimalAndNull(WeightCalculatorRequest.FinishWeight, getConfigurationKey().NoOfDecimalForInputOutput) : '',
    }

    const { register, handleSubmit, control, setValue, getValues, reset, formState: { errors }, } = useForm({
        mode: 'onChange',
        reValidateMode: 'onChange',
        defaultValues: defaultValues,
    })

    const fieldValues = useWatch({
        control,
        name: ['InnerDiameter', 'OuterDiameter', 'Length', 'CuttingAllowance', 'FinishWeight'],
    })

    useEffect(() => {

        calculateTotalLength()
        calculateVolume()
        calculateScrapWeight()

    }, [fieldValues])


    useEffect(() => {

        let arr = []
        let count = 0
        rmData && rmData.map((item) => {
            arr.push({
                label: item.RMName, value: count
            })
            count++
            return null
        })
        setRmDropDownData(arr)
    }, [])


    useEffect(() => {


    }, [tableData])

    useEffect(() => {
        if (Number(getValues('FinishWeight') < dataToSend.GrossWeight)) {
            delete errors.FinishWeight
            setRerender(!reRender)
        }
    }, [dataToSend.GrossWeight])
    const handleInnerDiameter = (e) => {
        const InnerDiameter = e
        const OuterDiameter = Number(getValues('OuterDiameter'))
        if (OuterDiameter > InnerDiameter) {
            delete errors.OuterDiameter
        }
    }

    const handleOuterDiameter = (e) => {
        const InnerDiameter = Number(getValues('InnerDiameter'))
        const OuterDiameter = e
        if (InnerDiameter < OuterDiameter) {
            delete errors.InnerDiameter
        }
    }

    const calculateTotalLength = () => {

        const Length = Number(getValues('Length'))
        const CuttingAllowance = Number(getValues('CuttingAllowance'))
        let TotalLength = checkForNull(Length) + checkForNull(CuttingAllowance)
        setDataToSend(prevState => ({ ...prevState, TotalLength: TotalLength }))
        setValue('TotalLength', checkForDecimalAndNull(TotalLength, getConfigurationKey().NoOfDecimalForInputOutput))

    }


    const calculateVolume = debounce(() => {

        const InnerDiameter = Number(getValues('InnerDiameter'))
        const OuterDiameter = Number(getValues('OuterDiameter'))

        if (InnerDiameter && OuterDiameter) {
            const Length = Number(getValues('Length'))
            const CuttingAllowance = Number(getValues('CuttingAllowance'))
            let Volume = 0.7857 * (Math.pow(checkForNull(OuterDiameter), 2) - Math.pow(checkForNull(InnerDiameter), 2)) * checkForNull(Length + CuttingAllowance)
            let GrossWeight = Volume * (checkForNull(rmRowDataState.Density) / 1000000)


            setDataToSend(prevState => ({ ...prevState, Volume: Volume, GrossWeight: GrossWeight }))
            setValue('Volume', checkForDecimalAndNull(Volume, getConfigurationKey().NoOfDecimalForInputOutput))
            setValue('GrossWeight', checkForDecimalAndNull(GrossWeight, getConfigurationKey().NoOfDecimalForInputOutput))
        }

    }, 500)


    const calculateScrapWeight = () => {

        const FinishWeight = Number(getValues('FinishWeight'))

        if (Number(getValues('GrossWeight'))) {
            let ScrapWeight = checkForNull(dataToSend.GrossWeight) - checkForNull(FinishWeight)
            setDataToSend(prevState => ({ ...prevState, ScrapWeight: ScrapWeight }))
            setValue('ScrapWeight', checkForDecimalAndNull(ScrapWeight, getConfigurationKey().NoOfDecimalForInputOutput))

            let NetRmCost = checkForNull(dataToSend.GrossWeight) * checkForNull(rmRowDataState.RMRate) - checkForNull(rmRowDataState.ScrapRate) * ScrapWeight
            setDataToSend(prevState => ({ ...prevState, NetRmCost: NetRmCost }))
            setValue('NetRmCost', checkForDecimalAndNull(NetRmCost, getConfigurationKey().NoOfDecimalForPrice))
        }

    }


    const handleRMDropDownChange = (e) => {
        rmData && rmData.map((item, index) => {
            if (item.RMName === e.label) {
                setRmRowDataState(rmData[index])
            }
            return false
        })

        if (tableData.length > 0) {

            let obj = tableData[tableData.length - 1]

            setValue('InnerDiameter', obj.OuterDiameter)
            setValue('Length', obj.Length)
            setValue('CuttingAllowance', obj.CuttingAllowance)
        }
    }

    const hyphenFormatter = (props) => {
        const cellValue = props?.value;
        return checkForDecimalAndNull(cellValue, getConfigurationKey().NoOfDecimalForInputOutput)
    }


    const deleteItem = (gridData) => {

        let arr = []
        let count = 0
        rmData && rmData.map((item) => {
            arr.push({
                label: item.RMName, value: count
            })
            count++
            return null
        })
        setAgGridTable(false)
        gridData.pop()
        // grid.applyTransaction({ remove: [rowData] })
        setTableData([...gridData])
        // setAgGridTable(true)
        let tableDataArray = [...gridData]
        let totalRMCost = tableDataArray && tableDataArray.reduce((accummlator, el) => {
            return accummlator + el.NetRmCost
        }, 0)
        setTotalRMCost(totalRMCost)


        /////

        let dropDown = []
        arr && arr.map((item) => {
            let count = 0
            gridData && gridData.map((ele) => {
                if (item.label === ele.RmName) {
                    count++
                }
                return null
            })

            if (count > 0) {
                return false
            } else {
                dropDown.push(item)
            }
            return null
        })
        setRmDropDownData(dropDown)
        /////
        setTimeout(() => {
            setAgGridTable(true)
        }, 300);
    }
    const editItem = (gridData) => {

        setDisableCondition(false)
        let e = gridData[gridData.length - 1]
        rmData && rmData.map((item, index) => {
            if (item.RMName === e.RmName) {
                setRmRowDataState(rmData[index])
            }
            return false
        })

        let obj = e
        setValue('InnerDiameter', checkForDecimalAndNull(obj.InnerDiameter, getConfigurationKey().NoOfDecimalForInputOutput))
        setValue('OuterDiameter', checkForDecimalAndNull(obj.OuterDiameter, getConfigurationKey().NoOfDecimalForInputOutput))
        setValue('Length', checkForDecimalAndNull(obj.Length, getConfigurationKey().NoOfDecimalForInputOutput))
        setValue('CuttingAllowance', checkForDecimalAndNull(obj.CuttingAllowance, getConfigurationKey().NoOfDecimalForInputOutput))
        setValue('Volume', checkForDecimalAndNull(obj.Volume, getConfigurationKey().NoOfDecimalForInputOutput))
        setValue('GrossWeight', checkForDecimalAndNull(obj.GrossWeight, getConfigurationKey().NoOfDecimalForInputOutput))
        setValue('FinishWeight', checkForDecimalAndNull(obj.FinishWeight, getConfigurationKey().NoOfDecimalForInputOutput))
        setTimeout(() => {
            setValue('ScrapWeight', checkForDecimalAndNull(obj.ScrapWeight, getConfigurationKey().NoOfDecimalForInputOutput))
        }, 200);

    }


    const buttonFormatter = (props) => {
        // props.gridApi?.applyTransaction({ remove: gridOptions.rowData })

        let isEditable;
        if ((props?.agGridReact?.gridOptions?.rowData.length - 1) === props.rowIndex) {
            isEditable = true
        } else {
            isEditable = false
        }

        return (
            <>

                {isEditable && <button title='Edit' className="Edit mr-2 align-middle" type={'button'} onClick={() => editItem(props?.agGridReact?.gridOptions.rowData)} />}
                {isEditable && <button title='Delete' className="Delete align-middle" type={'button'} onClick={() => deleteItem(props?.agGridReact?.gridOptions.rowData)} />}
            </>
        )
    };


    const defaultColDef = {
        resizable: true,
        filter: true,
        sortable: false,

    };

    const onGridReady = (params) => {

        params.api.sizeColumnsToFit();
        setGridColumnApi(params.columnApi)
        setGridApi(params.api)
        params.api.paginationGoToPage(0);
    };

    const addRow = () => {
        if (Object.keys(errors).length > 0) {
            return false
        }
        if (Number(getValues('FinishWeight')) > dataToSend.GrossWeight) {
            Toaster.warning('Finish weight cannot be greater than gross weight')
            return false
        }
        let obj = {
            RmName: rmRowDataState.RMName,
            InnerDiameter: Number(getValues('InnerDiameter')),
            OuterDiameter: Number(getValues('OuterDiameter')),
            Length: Number(getValues('Length')),
            CuttingAllowance: Number(getValues('CuttingAllowance')),
            TotalLength: dataToSend.TotalLength,
            Volume: dataToSend.Volume,
            GrossWeight: dataToSend.GrossWeight,
            FinishWeight: Number(getValues('FinishWeight')),
            ScrapWeight: dataToSend.ScrapWeight,
            NetRmCost: dataToSend.NetRmCost,

        }

        if (obj.InnerDiameter === 0 || obj.OuterDiameter === 0 || obj.Length === 0 || obj.CuttingAllowance === 0) {

            Toaster.warning("Please fill all the mandatory fields first.")
            return false;
        }


        if (disableCondition) {
            setTableData([...tableData, obj])
        } else {
            let array = [...tableData]
            array.pop()
            setTableData([...array, obj])
        }


        reset({
            InnerDiameter: "",
            OuterDiameter: "",
            Length: "",
            CuttingAllowance: "",
            TotalLength: "",
            Volume: "",
            GrossWeight: "",
            FinishWeight: "",
            ScrapWeight: "",
            NetRmCost: "",
            RawMaterial: []

        })
        setRmRowDataState({})

        setTimeout(() => {
            setValue('ScrapWeight', 0)
        }, 300);


        let arr2 = rmDropDownData && rmDropDownData.filter((item) => {
            return item.label !== obj.RmName
        })
        setRmDropDownData(arr2)

        let tableDataArray = [...tableData, obj]

        let totalRMCost = tableDataArray && tableDataArray.reduce((accummlator, el) => {
            return accummlator + el.NetRmCost
        }, 0)

        setTotalRMCost(totalRMCost)
        setDisableCondition(true)


    }

    const onCancel = () => {

        reset({

            InnerDiameter: "",
            OuterDiameter: "",
            Length: "",
            CuttingAllowance: "",
            TotalLength: "",
            Volume: "",
            GrossWeight: "",
            FinishWeight: "",
            ScrapWeight: "",
            NetRmCost: "",
            RawMaterial: []

        })
        setRmRowDataState({})

        setTimeout(() => {
            setValue('ScrapWeight', 0)
        }, 300);
        setDisableCondition(true)


    }

    const onSubmit = debounce(handleSubmit(() => {
        setIsDisable(true)
        let obj = {}
        obj.LayoutType = 'Default'
        obj.WeightCalculationId = WeightCalculatorRequest && WeightCalculatorRequest.WeightCalculationId ? WeightCalculatorRequest.WeightCalculationId : "00000000-0000-0000-0000-000000000000"
        obj.IsChangeApplied = true //NEED TO MAKE IT DYNAMIC how to do
        obj.PartId = costData.PartId
        obj.RawMaterialId = rmRowData.RawMaterialId
        obj.CostingId = costData.CostingId
        obj.TechnologyId = costData.TechnologyId
        // obj.CostingRawMaterialDetailId = rmRowData.RawMaterialDetailId
        // obj.NetLandedCost = grossWeights * rmRowData.RMRate - (grossWeights - getValues('finishWeight')) * rmRowData.ScrapRate
        // obj.PartNumber = costData.PartNumber
        // obj.TechnologyName = costData.TechnologyName
        obj.UOMForDimension = KG
        obj.RmDropDownData = rmDropDownData
        obj.CalculatedRmTableData = tableData

        //APPLY NEW ACTION HERE 

    }), 500)

    const cancel = () => {
        props.toggleDrawer('')
    }

    const frameworkComponents = {
        hyphenFormatter: hyphenFormatter,
        totalValueRenderer: buttonFormatter,

    };

    const UnitFormat = () => {
        return <>Volume(mm<sup>3</sup>)</>
    }

    const handleKeyDown = function (e) {
        if (e.key === 'Enter' && e.shiftKey === false) {
            e.preventDefault();
        }
    };
    let volumeFormula = <div>Volume = 0.7857 * (Major Diameter<sup>2</sup> - Minor Diameter <sup>2</sup>) * Length</div>
    return (
        <Fragment>
            <Row>
                <Col>
                    <form noValidate className="form"
                        // onSubmit={handleSubmit(onSubmit)}
                        onKeyDown={(e) => { handleKeyDown(e, onSubmit.bind(this)); }}>
                        <Col md="12" className={'mt25'}>
                            <div className="border pl-3 pr-3 pt-3">
                                {/* <Col md="12">
                                    <div className="left-border">
                                        {'Input Weight:'}
                                    </div>
                                </Col> */}
                                <Col md="12">


                                    <Row className="mb-4 pb-2">
                                        <Col md="12 d-flex weight-calculator-headings">
                                            <div className="d-inline-block "><span className="grey-text d-block">RM Name:</span><span className="text-dark-blue one-line-overflow" title={rmRowDataState.RMName}>{`${rmRowDataState.RMName !== undefined ? rmRowDataState.RMName : ''}`}</span></div>
                                            <div className="d-inline-block "><span className="grey-text d-block">Material:</span><span className="text-dark-blue">{`${rmRowDataState.MaterialType !== undefined ? rmRowDataState.MaterialType : ''}`}</span></div>
                                            <div className="d-inline-block "><span className="grey-text d-block">Density(g/cm){<sup>3</sup>}:</span><span className="text-dark-blue">{`${rmRowDataState.Density !== undefined ? rmRowDataState.Density : ''}`}</span></div>
                                            <div className="d-inline-block "><span className="grey-text d-block">RM Rate ({reactLocalStorage.getObject("baseCurrency")}):</span><span className="text-dark-blue">{`${rmRowDataState.RMRate !== undefined ? rmRowDataState.RMRate : ''}`}</span></div>
                                            {props?.appyMasterBatch && < div className="d-inline-block "><span className="grey-text d-block">RM Rate(including Master Batch):</span><span className="text-dark-blue">{`${rmRowDataState.RMRate !== undefined ? checkForDecimalAndNull(5, getConfigurationKey().NoOfDecimalForInputOutput) : ''}`}</span></div>}
                                            <div className="d-inline-block "><span className="grey-text d-block">Scrap Rate ({reactLocalStorage.getObject("baseCurrency")}):</span><span className="text-dark-blue">{`${rmRowDataState.ScrapRate !== undefined ? rmRowDataState.ScrapRate : ''}`}</span></div>
                                            <div className="d-inline-block"><span className="grey-text d-block">Category:</span><span className="text-dark-blue">{`${rmRowDataState.RawMaterialCategory !== undefined ? rmRowDataState.RawMaterialCategory : ''}`}</span></div>

                                        </Col>
                                    </Row>

                                    <Col md="3">
                                        <SearchableSelectHookForm
                                            label={`Raw Material`}
                                            name={'RawMaterial'}
                                            placeholder={'Select'}
                                            Controller={Controller}
                                            control={control}
                                            register={register}
                                            mandatory={false}
                                            options={rmDropDownData}
                                            handleChange={handleRMDropDownChange}
                                            defaultValue={''}
                                            className=""
                                            customClassName={'withBorder'}
                                            errors={errors.RawMaterial}
                                            disabled={props.CostingViewMode || !disableCondition ? true : false}
                                        />
                                    </Col>

                                    <Row className={'mt15'}>
                                        <Col md="3">
                                            <TextFieldHookForm
                                                label={`Inner Diameter(mm)`}
                                                name={'InnerDiameter'}
                                                Controller={Controller}
                                                control={control}
                                                register={register}
                                                mandatory={false}
                                                rules={{
                                                    required: false,
                                                    validate: { number, decimalAndNumberValidation },
                                                    max: {
                                                        value: getValues('OuterDiameter') - 0.00000001, // adjust the threshold here acc to decimal validation above,
                                                        message: 'Inner Diameter should not be greater than outer diameter.'
                                                    },
                                                }}
                                                handleChange={(e) => handleInnerDiameter(e.target.value)}
                                                defaultValue={''}
                                                className=""
                                                customClassName={'withBorder'}
                                                errors={errors.InnerDiameter}
                                                disabled={(props.isEditFlag && Object.keys(rmRowDataState).length > 0 ? false : true) || ((tableData.length > 0 && disableCondition) ? true : false)}
                                            />
                                        </Col>
                                        <Col md="3">
                                            <TextFieldHookForm
                                                label={`Outer Diameter(mm)`}
                                                name={'OuterDiameter'}
                                                Controller={Controller}
                                                control={control}
                                                register={register}
                                                mandatory={false}
                                                rules={{
                                                    required: false,
                                                    validate: { number, decimalAndNumberValidation },
                                                    min: {
                                                        value: parseFloat(getValues('InnerDiameter')) + 0.00000001, // adjust the threshold here acc to decimal validation above
                                                        message: 'Outer Diameter should be greater than the inner diameter.'
                                                    },
                                                }}
                                                handleChange={(e) => handleOuterDiameter(e.target.value)}
                                                defaultValue={''}
                                                className=""
                                                customClassName={'withBorder'}
                                                errors={errors.OuterDiameter}
                                                disabled={props.isEditFlag && Object.keys(rmRowDataState).length > 0 ? false : true}
                                            />
                                        </Col>
                                        <Col md="3">
                                            <TextFieldHookForm
                                                label={`Length(mm)`}
                                                name={'Length'}
                                                Controller={Controller}
                                                control={control}
                                                register={register}
                                                mandatory={false}
                                                rules={{
                                                    required: false,
                                                    validate: { number, decimalAndNumberValidation },
                                                }}
                                                handleChange={() => { }}
                                                defaultValue={''}
                                                className=""
                                                customClassName={'withBorder'}
                                                errors={errors.Length}
                                                disabled={(props.isEditFlag && Object.keys(rmRowDataState).length > 0 ? false : true) || ((tableData.length > 0 && disableCondition) ? true : false)}
                                            />
                                        </Col>

                                        <Col md="3">
                                            <TextFieldHookForm
                                                label={`Cutting Allowance(mm)`}
                                                name={'CuttingAllowance'}
                                                Controller={Controller}
                                                control={control}
                                                register={register}
                                                mandatory={false}
                                                rules={{
                                                    required: false,
                                                    validate: { number, decimalAndNumberValidation },
                                                }}
                                                handleChange={() => { }}
                                                defaultValue={''}
                                                className=""
                                                customClassName={'withBorder'}
                                                errors={errors.CuttingAllowance}
                                                disabled={(props.isEditFlag && Object.keys(rmRowDataState).length > 0 ? false : true) || ((tableData.length > 0 && disableCondition) ? true : false)}
                                            />
                                        </Col>


                                        <Col md="3">
                                            <TooltipCustom disabledIcon={true} id={'rubber-total-length'} tooltipText={"Total Length = Length + Cutting allowance "} />
                                            <TextFieldHookForm
                                                label={`Total Length(mm)`}
                                                id={'rubber-total-length'}
                                                name={'TotalLength'}
                                                Controller={Controller}
                                                control={control}
                                                register={register}
                                                mandatory={false}
                                                handleChange={() => { }}
                                                defaultValue={''}
                                                className=""
                                                customClassName={'withBorder'}
                                                errors={errors.grossWeight}
                                                disabled={true}
                                            />
                                        </Col>

                                        <Col md="3">
                                            <TooltipCustom disabledIcon={true} tooltipClass={'weight-of-sheet'} id={'rubber-volume'} tooltipText={volumeFormula} />
                                            <TextFieldHookForm
                                                label={UnitFormat()}
                                                name={'Volume'}
                                                id={'rubber-volume'}
                                                Controller={Controller}
                                                control={control}
                                                register={register}
                                                mandatory={false}
                                                handleChange={() => { }}
                                                defaultValue={''}
                                                className=""
                                                customClassName={'withBorder'}
                                                errors={errors.Volume}
                                                disabled={true}
                                            />
                                        </Col>

                                        <Col md="3">
                                            <TooltipCustom disabledIcon={true} id={'rubber-gross-weight'} tooltipText={"Gross Weight = Volume * Density / 1000000"} />
                                            <TextFieldHookForm
                                                label={`Gross Weight(Kg)`}
                                                name={'GrossWeight'}
                                                id={'rubber-gross-weight'}
                                                Controller={Controller}
                                                control={control}
                                                register={register}
                                                mandatory={false}
                                                handleChange={() => { }}
                                                defaultValue={''}
                                                className=""
                                                customClassName={'withBorder'}
                                                errors={errors.grossWeight}
                                                disabled={true}
                                            />
                                        </Col>

                                        <Col md="3">
                                            <TextFieldHookForm
                                                label={`Finish Weight(Kg)`}
                                                name={'FinishWeight'}
                                                Controller={Controller}
                                                control={control}
                                                register={register}
                                                mandatory={false}
                                                rules={{
                                                    required: false,
                                                    validate: { number, decimalAndNumberValidation },
                                                    max: {
                                                        value: getValues('GrossWeight'),
                                                        message: 'Finish weight should not be greater than gross weight.'
                                                    },
                                                }}
                                                handleChange={() => { }}
                                                defaultValue={''}
                                                className=""
                                                customClassName={'withBorder'}
                                                errors={errors.FinishWeight}
                                                disabled={props.isEditFlag && Object.keys(rmRowDataState).length > 0 ? false : true}
                                            />
                                        </Col>

                                        <Col md="3">
                                            <TooltipCustom disabledIcon={true} id={'rubber-scrap-weight'} tooltipText={"Scrap Weight = Gross Weight - Finished Weight"} />
                                            <TextFieldHookForm
                                                label={`Scrap Weight(Kg)`}
                                                name={'ScrapWeight'}
                                                id={'rubber-scrap-weight'}
                                                Controller={Controller}
                                                control={control}
                                                register={register}
                                                mandatory={false}
                                                handleChange={() => { }}
                                                defaultValue={''}
                                                className=""
                                                customClassName={'withBorder'}
                                                errors={errors.ScrapWeight}
                                                disabled={true}
                                            />
                                        </Col>

                                        <Col md="3">
                                            <TooltipCustom disabledIcon={true} id={'rubber-cost-component'} tooltipClass={'weight-of-sheet'} tooltipText={"Net RM Cost/Component = Gross Weight * RMRate - Scrap Rate * Scrap Weight"} />
                                            <TextFieldHookForm
                                                label={`Net RM Cost/Component`}
                                                name={'NetRmCost'}
                                                id={'rubber-cost-component'}
                                                Controller={Controller}
                                                control={control}
                                                register={register}
                                                mandatory={false}
                                                handleChange={() => { }}
                                                defaultValue={''}
                                                className=""
                                                customClassName={'withBorder'}
                                                errors={errors.NetRmCost}
                                                disabled={true}
                                            />
                                        </Col>

                                        <button
                                            type="button"
                                            className={'user-btn mt30 pull-left ml-3'}
                                            onClick={() => addRow()}
                                            disabled={props.isEditFlag && Object.keys(rmRowDataState).length > 0 ? false : true}
                                        >
                                            <div className={'plus'}></div>{disableCondition ? "ADD" : "UPDATE"}
                                        </button>

                                        <button
                                            onClick={onCancel} // Need to change this cancel functionality
                                            type="submit"
                                            value="CANCEL"
                                            className="reset ml-2 cancel-btn mt30"
                                            disabled={props.isEditFlag && Object.keys(rmRowDataState).length > 0 ? false : true}
                                        >
                                            <div className={''}></div>
                                            RESET
                                        </button>

                                    </Row>
                                </Col>
                            </div>
                            {!agGridTable && <LoaderCustom />}

                            {agGridTable && <Row>
                                <Col>
                                    <div className={`ag-grid-wrapper height-width-wrapper ${tableData && tableData.length <= 0 ? "overlay-contain" : ""} `}>

                                        <div className={`ag-theme-material  max-loader-height`}>
                                            <AgGridReact
                                                defaultColDef={defaultColDef}
                                                //floatingFilter={true}
                                                domLayout='autoHeight'
                                                // columnDefs={c}
                                                rowData={tableData}
                                                //pagination={true}
                                                paginationPageSize={10}
                                                onGridReady={onGridReady}
                                                gridOptions={gridOptions}
                                                noRowsOverlayComponent={'customNoRowsOverlay'}
                                                noRowsOverlayComponentParams={{
                                                    title: EMPTY_DATA,
                                                }}
                                                frameworkComponents={frameworkComponents}
                                            >
                                                <AgGridColumn minWidth="150" field="RmName" headerName="RM Name" ></AgGridColumn>
                                                <AgGridColumn minWidth="150" field="InnerDiameter" headerName="Inner Dia" cellRenderer={'hyphenFormatter'}></AgGridColumn>
                                                <AgGridColumn minWidth="150" field="OuterDiameter" headerName="Outer Dia " cellRenderer={'hyphenFormatter'}></AgGridColumn>
                                                <AgGridColumn minWidth="150" field="Length" headerName="Length(mm)" cellRenderer={'hyphenFormatter'}></AgGridColumn>
                                                <AgGridColumn minWidth="150" field="CuttingAllowance" headerName="Cutting Allowance" cellRenderer={'hyphenFormatter'}></AgGridColumn>
                                                <AgGridColumn minWidth="150" field="TotalLength" headerName="TotalLength" cellRenderer={'hyphenFormatter'}></AgGridColumn>
                                                <AgGridColumn minWidth="150" field="Volume" headerName="Volume" cellRenderer={'hyphenFormatter'}></AgGridColumn>
                                                <AgGridColumn minWidth="150" field="GrossWeight" headerName="Gross Weight" cellRenderer={'hyphenFormatter'}></AgGridColumn>
                                                <AgGridColumn minWidth="150" field="FinishWeight" headerName="Finish Weight" cellRenderer={'hyphenFormatter'}></AgGridColumn>
                                                <AgGridColumn minWidth="150" field="ScrapWeight" headerName="Scrap Weight" cellRenderer={'hyphenFormatter'}></AgGridColumn>
                                                <AgGridColumn minWidth="150" field="NetRmCost" headerName="Net RM Cost/Component" cellRenderer={'hyphenFormatter'}></AgGridColumn>
                                                <AgGridColumn minWidth="120" field="ProcessId" cellClass="ag-grid-action-container" headerName="Action" type="rightAligned" floatingFilter={false} cellRenderer={'totalValueRenderer'}></AgGridColumn>
                                            </AgGridReact>

                                        </div>
                                    </div>
                                </Col>
                            </Row>
                            }

                            <div className="bluefooter-butn text-right">
                                <span className='pr-2'>Total RM Cost : <span >{checkForDecimalAndNull(totalRMCost, getConfigurationKey().NoOfDecimalForPrice)}</span></span>
                            </div>

                        </Col>
                        <div className="mt25 col-md-12 text-right">
                            <button
                                onClick={cancel} // Need to change this cancel functionality
                                type="submit"
                                value="CANCEL"
                                className="reset mr15 cancel-btn"
                            >
                                <div className={'cancel-icon'}></div>
                                CANCEL
                            </button>

                            <button
                                type="button"
                                className="submit-button  save-btn"
                                onClick={onSubmit}
                                disabled={props.CostingViewMode || isDisable ? true : false}
                            >
                                <div className={'save-icon'}></div>
                                {'SAVE'}
                            </button>
                        </div>
                    </form>
                </Col >
            </Row >
        </Fragment >
    )
}

export default StandardRub;